module.exports = __webpack_public_path__ + "img/03.d6fdf8fe.png";